module.exports = __webpack_public_path__ + "img/新闻资讯banner.e1394348.png";